import {PureComponent, Fragment} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'

import {generate} from '../../routes.js'

import ArticlesList from '../../components/Blog/ArticlesList.jsx'

import ArticleCard from '../../components/Blog/ArticleCard/ArticleCard.jsx'
import DefaultLayout from '../Layout/DefaultLayout.jsx'
import Header from '../../components/Header/Header.jsx'
import Sidebar from './Sidebar.jsx'

import {loadArticles} from '../../components/Blog/actions.js'

class Blog extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      articles: []
    }
  }

  componentDidMount() {
    this.loadArticles()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevProps?.match?.params?.slug !== this.props?.match?.params?.slug) {
      this.loadArticles()
    }
  }

  loadArticles = () => {
    this.props.loadArticles().then((articles) => {
      let filteredArticles = []
      const requestSlug = this.props?.match?.params?.slug ?? null

      if (requestSlug !== null) {
        if (this.props.route.name === 'blog-category') {
          filteredArticles = articles.filter(article => (article.category.slug === requestSlug))
        }
        if (this.props.route.name === 'blog-tag') {
          filteredArticles = articles.filter(article => {
            const tags = article.tags.map(tag => tag.slug)
            return tags.includes(requestSlug)
          })
        }
      } else {
        filteredArticles = articles
      }
      this.setState({
        articles: filteredArticles
      })
    })
  }

  render() {
    const title = "Twineeds | Blog sur le Conseil Indépendant, le Recrutement & le Freelance"
    const description = "Explorez nos articles sur le freelancing, le conseil indépendant et les évolutions du recrutement. Un blog dédié aux consultants experts et entreprises."
    const headerBrief = <Fragment>
      <p>Bienvenue sur le <strong>blog Twineeds</strong>, votre guide dédié aux <strong>consultants indépendant et aux entreprises</strong> dans les domaines de <strong>l'Ingénierie, de la Finance, des Achats & Supply Chain et des Ressouces Humaines</strong>.</p>
      <p>A la recherche d'une activité ? Retrouvez des <strong>conseils et bonnes pratiques</strong> pour <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'devenir-consultant-independant'}})} className="is-underline" target="_blank" rel="noopener noreferrer">démarrer votre activité d'indépendant</Link></strong>: <strong>comparatifs de statuts juridiques, articles sur le portage salarial</strong> et <strong>retours d'expérience</strong> terrain. Que vous soyez en cours de lancement, déjà indépendant, ou simplement curieux, notre blog vous aide à faire les bons choix pour votre carrière.</p>
      <p>À la recherche de consultants externes ? Notre blog guide les entreprises dans le choix des bons profils, pour mener à bien leurs projets et optimiser leurs investissements en ressources.</p>
    </Fragment>

    return <DefaultLayout showSidebarMenu={false} helmet={{title, description}} className="blog">
      <Header brief={headerBrief} title="Le blog dédié aux missions consultants : la référence pour entreprises et indépendants"/>
      <section className="container d-flex flex-column flex-md-row my-md-5">
        <ArticlesList
          className="col-sm-9"
          articles={this.state.articles}
          card={ArticleCard}
          flex={false}
        />
        <Sidebar
          className="col-sm-3"
          articles={this.props.articles.slice(0, 5)}
        />
      </section>
    </DefaultLayout>
  }
}

export default connect(
  state => ({
    articles: state.blog.articles,
  }),
  dispatch => ({
    loadArticles: () => dispatch(loadArticles()),
  })
)(Blog)
